const OPERATORS_BY_TYPE: any = {
    date: [
        { name: "equal", displayName: "Igual a" },
        { name: "greaterThan", displayName: "Mayor que" },
        { name: "greaterThanOrEqual", displayName: "Mayor o igual que" },
        { name: "lessThan", displayName: "Menor que" },
        { name: "lessThanOrEqual", displayName: "Menor o igual que" },
        { name: "between", displayName: "Entre" },
        { name: "isNull", displayName: "Es nulo" },
        { name: "isNotNull", displayName: "No es nulo" }
    ],
    text: [
        { name: "equal", displayName: "Igual a" },
        { name: "notEqual", displayName: "Diferente de" },
        { name: "like", displayName: "Coincide parcialmente" },
        { name: "notLike", displayName: "No coincide parcialmente" },
        { name: "isNull", displayName: "Es nulo" },
        { name: "isNotNull", displayName: "No es nulo" }
    ],
    number: [
        { name: "equal", displayName: "Igual a" },
        { name: "notEqual", displayName: "Diferente de" },
        { name: "greaterThan", displayName: "Mayor que" },
        { name: "greaterThanOrEqual", displayName: "Mayor o igual que" },
        { name: "lessThan", displayName: "Menor que" },
        { name: "lessThanOrEqual", displayName: "Menor o igual que" },
        { name: "between", displayName: "Entre" },
        { name: "isNull", displayName: "Es nulo" },
        { name: "isNotNull", displayName: "No es nulo" }
    ],
    boolean: [
        { name: "equal", displayName: "Igual a" },
        { name: "notEqual", displayName: "Diferente de" },
        { name: "isNull", displayName: "Es nulo" },
        { name: "isNotNull", displayName: "No es nulo" }
    ]
};

export const prepareFilterConfigurations = (inputFilters: any) => {
    return inputFilters?.map((filter: any) => {
        const operators = OPERATORS_BY_TYPE[filter.type] || [];
        return {
            ...filter,
            operator: operators.length > 0 ? operators[0].name : "equal",
            value: null,
            active: false,
            availableOperators: operators
        };
    });
}
